<template>
  <swiper :options="swiperOptions"  ref="mySwiper" class="freeswiper_box" style="overflow:hidden;width:100%;height:300px;">
    <swiper-slide v-for="(item, index) in list" :key="index" >
      <img  :src="item.img" :data-index="index" class="freeswiper_slide_img radius10 automargin">
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>


export default {
  name: 'freeswiper',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    onClickImg: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      swiperOptions: {
        // 基础配置
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        initialSlide: 0, // 从第一张幻灯片开始（无效）

        // preventClicks: false,      // 重要：允许点击
        // preventClicksPropagation: false, // 重要：允许事件传播
        
        // 分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        
        // 自动播放
        autoplay: {
          delay: 3000, // 3秒切换
          disableOnInteraction: false, // 用户交互后是否停止
          pauseOnMouseEnter: true, // 鼠标悬停暂停
          waitForTransition: true, // 等待过渡完成
          stopOnLastSlide: false, // 最后一张停止（loop=true时无效）
          reverseDirection: false // 反向播放
        },

        // 初始化回调
        on: {
          // Swiper 初始化完成
          init: () => {
            console.log('Swiper init 事件触发')
            this.swiperStatus = 'ready'
            this.swiperStatusText = '已就绪'
            
            // 关键：Swiper 初始化后绑定事件
            this.$nextTick(() => {
              // this.bindClickEvents()
              
              // 以下无效
              // this.$refs.mySwiper.$swiper.update() // 更新
              // this.$refs.mySwiper.$swiper.slideTo(0, 0, false); // 从第一张幻灯片开始，0 是索引，0 是速度，false 表示不发送回调。
            })
          },
          
          // Swiper 准备就绪
          ready: () => {
            console.log('Swiper ready 事件触发')
          },
          
          // 幻灯片变化
          slideChange: (swiper) => {
            console.log("幻灯片变化，当前索引",  swiper )
          },
          
          // 点击幻灯片事件（Swiper 内置）
          click: (swiper, event) => {
              let currIndex= swiper.target.dataset.index;
              console.log('Swiper 点击事件1:', swiper.target, currIndex)
              if( typeof currIndex!='undefined' )this.onClickImg(currIndex);//发送父页面
              // if(swiper){
              //   var target=swiper.target;
              //   var reg=/data-index="(1)"/
              //   var m=target.match(reg);
              //   console.log(m);
              //   if(typeof m=="object"){ m=m[0]; }  //数组
              //   this.onClickImg(m);//发送父页面
              // }
          }
        }


      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper
    }
  },
  mounted(){

    
    console.log("swiper mounted....");

    this.$nextTick(() => {
      //设置图片正方形
      let img_width=window.$('.freeswiper_box').width();
      window.$('.freeswiper_box').css("height", img_width+"px");
      console.log("swiper img_width...."+img_width);

      
    })

   
  
  },

  methods: {
    
    clickImg(item){
        console.log("点击序号：",item);
        this.onClickImg(item);//发送父页面
    },

     // 关键方法：绑定点击事件
    bindClickEvents() {
      console.log("=============llll",this.list.length);
      
      // // 方法1：通过动态 ref 名称获取
      // for (let i = 1; i <= this.list.length; i++) {
      //   const refName = 'swiperimg_'+i;
      //   const element = this.$refs[refName]
      //   if (element) {
      //     // // 注意：v-for 中的 ref 会返回数组
      //     // if (Array.isArray(element)) {
      //     //   refs.push(...element)
      //     // } else {
      //     //   refs.push(element)
      //     // }
      //     element.removeEventListener('click', this.clickImg)
      //     // 添加新的事件监听器
      //     element.addEventListener('click', (event) => {
      //       this.clickImg(index, event)
      //     }, { passive: true })
      //     console.log("添加新的事件监听器");
      //   }
      // }


      // const slides = this.$refs.
      // this.clickAreaCount = slides.length
      
      // slides.forEach((slide, index) => {
      //   // 移除旧的事件监听器
      //   slide.removeEventListener('click', this.clickImg)
        
      //   // 添加新的事件监听器
      //   slide.addEventListener('click', (event) => {
      //     this.clickImg(index, event)
      //   }, { passive: true })
        
      //   console.log(`✅ 绑定事件到 slide ${index}`)
      // })
      
      // // 方法2：使用事件委托（推荐）
      // const swiperContainer = this.swiper.$el
      // if (swiperContainer) {
      //   swiperContainer.addEventListener('click', this.handleContainerClick, true)
      //   console.log('✅ 绑定容器事件委托')
      // }
      
      // // 方法3：检查第一个 slide 的特殊处理
      // this.checkFirstSlide()
    },


    // initSwiper() {
    //    this.$nextTick(() => {
    //     if (this.swiper) {
    //       // 如果 autoplay 不存在，手动创建
    //       if (!this.swiper.autoplay) {
    //         console.warn('Autoplay 模块未加载，尝试手动初始化')
    //         // 重新设置参数
    //         this.swiper.params.autoplay = {
    //           delay: 3000,
    //           disableOnInteraction: false
    //         }
    //         // 重新初始化 Swiper
    //         this.swiper.destroy()
    //         this.swiper.init()
    //         // 使用模拟 autoplay
    //         this.startMockAutoplay()
    //       }
    //     }
    //   });
    //   this.$nextTick(() => {
    //     if (this.swiper) {
    //       this.swiperInstance = this.swiper
    //       console.log('Swiper 实例:', this.swiperInstance)
    //       // 检查 autoplay 是否启用
    //       if (this.swiperInstance.autoplay) {
    //         console.log('Autoplay 模块已加载')
    //         this.updateAutoplayStatus()
    //       } else {
    //         console.warn('Autoplay 模块未加载！')
    //         this.debugAutoplay()
    //       }
    //     }
    //   })
    // },
    
    onSwiperReady(swiper) {
      console.log('Swiper ready:', swiper)
      this.swiperInstance = swiper
      this.updateAutoplayStatus()
    },
    
    onSlideChange() {
      if (this.swiperInstance) {
        this.currentSlide = this.swiperInstance.realIndex
      }
    },
    
    // 调试 autoplay
    debugAutoplay() {
      console.log('=== Autoplay 调试信息 ===')
      console.log('1. swiperOptions.autoplay:', this.swiperOptions.autoplay)
      console.log('2. swiperInstance.autoplay:', this.swiperInstance.autoplay)
      console.log('3. swiperInstance.params.autoplay:', this.swiperInstance.params.autoplay)
      
      // 检查是否缺少 autoplay 模块
      if (this.swiperInstance && !this.swiperInstance.autoplay) {
        console.error('错误: Autoplay 模块未加载！')
        console.log('解决方案: 确保导入并使用了 Autoplay 模块')
      }
    },
    
    // 更新自动播放状态
    updateAutoplayStatus() {
      if (this.swiperInstance.autoplay.running) {
        this.autoplayStatus = 'playing'
      } else {
        this.autoplayStatus = 'stopped'
      }
    },
    
    // 控制方法
    startAutoplay() {
      if (this.swiperInstance.autoplay.start) {
        this.swiperInstance.autoplay.start()
        this.autoplayStatus = 'playing'
        console.log('手动启动自动播放')
      } else {
        console.error('无法启动自动播放: autoplay.start 不存在')
        this.debugAutoplay()
      }
    },
    
    stopAutoplay() {
      if (this.swiperInstance.autoplay.stop) {
        this.swiperInstance.autoplay.stop()
        this.autoplayStatus = 'stopped'
        console.log('手动停止自动播放')
      }
    },
    
    toggleAutoplay() {
      if (this.swiperInstance.autoplay) {
        if (this.autoplayStatus === 'playing') {
          this.swiperInstance.autoplay.stop()
        } else {
          this.swiperInstance.autoplay.start()
        }
      }
    },
    
    // 重置到第一张
    goToFirstSlide() {
      if (this.swiperInstance) {
        this.swiperInstance.slideToLoop(0, 0)
      }
    },
    
    // 设置自动播放延迟
    setAutoplayDelay(delay) {
      if (this.swiperInstance.params.autoplay) {
        this.swiperInstance.params.autoplay.delay = delay
        if (this.swiperInstance.autoplay.running) {
          this.swiperInstance.autoplay.stop()
          this.swiperInstance.autoplay.start()
        }
      }
    }
  }


}
</script>

<style scoped>
.freeswiper_slide_img {
    width: calc(100% - 30px);
    height: auto;
    object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/freeswiper/freeswiper.vue